import { createPortal } from 'react-dom';

// Generic portal component to render children at the document body level
export default function ModalPortal({ children }) {
  return createPortal(children, document.body);
}
